export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
